import { getQuery } from '../monitoring/utils';

export const setupLocale = () => {
  const INTL_LOCALE_OVERRIDES = {
    no: 'nb',
  };
  let locale = window.__WIX_LOCALE__ || getQuery().locale || 'en';
  if (!/^[a-z]{2}$/.test(locale)) {
    locale = 'en';
  }
  window.__WIX_LOCALE__ = locale;
  window.__LOCALE__ = INTL_LOCALE_OVERRIDES[window.__WIX_LOCALE__] || window.__WIX_LOCALE__;
};
